module.exports = __webpack_public_path__ + "img/icon-action-account-circle-24-px.3770f6d8.svg";